import React from 'react';
import { Link } from '@material-ui/core';
import { Col, Container, Row } from 'react-bootstrap';
import { paperlessPages } from '../../menu';

const Footer = () => (

	<div className="main-footer text-center">
		<Container>
			<Row className="row-sm">
				<Col md={12} className="col-md-12">
					<img
					src={require("../../assets/img/brand/icon.png")}
					className="header-brand-img desktop-logo"
					alt={"logo1"}
					style={{width:"40px"}}
					/>
					<span style={{fontSize:"16px"}}>悦程信息</span>&nbsp;&nbsp;
					<span style={{fontSize:"16px"}}><a href="http://www.yczxtech.com">http://www.yczxtech.com</a></span>
				</Col>
			</Row>
		</Container>
	</div>
);

Footer.propTypes = {};

Footer.defaultProps = {};

export default Footer;
